import { render, staticRenderFns } from "./SupplierPaymentTable.vue?vue&type=template&id=b2f57766&scoped=true"
import script from "./SupplierPaymentTable.vue?vue&type=script&lang=js"
export * from "./SupplierPaymentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f57766",
  null
  
)

export default component.exports